// @flow

import PubSub from 'pubsub-js';
import React from 'react';

var ObservableTypes;
(function (ObservableTypes) {
    ObservableTypes["TOAST"] = "solvay_platform.toast";
    ObservableTypes["PAGE_TITLE"] = "solvay_platform.page.title";
    ObservableTypes["QUICK_NAVIGATOR"] = "solvay_platform.page.quickNavigator";
})(ObservableTypes || (ObservableTypes = {}));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var pageTitleObservableId = ObservableTypes.PAGE_TITLE;
var setPageTitle = function (newTitle) {
    PubSub.publish(pageTitleObservableId, newTitle);
};
var removePageTitle = function () {
    PubSub.publish(pageTitleObservableId, null);
};
var PageTitleObservable = {
    setPageTitle: setPageTitle,
    removePageTitle: removePageTitle,
    observable: __assign(__assign({}, PubSub), { subscribe: function (func) {
            PubSub.subscribe(pageTitleObservableId, func);
        } }),
};

// NOTE: These should be EXACTLY the same as the MS_frontend/src/utils/quickNavigator.js file.
var QuickNavigatorTypes;
(function (QuickNavigatorTypes) {
    QuickNavigatorTypes["NOTHING"] = "NOTHING";
    QuickNavigatorTypes["QUICK_NAVIGATOR_BACK"] = "QUICK_NAVIGATOR_BACK";
    QuickNavigatorTypes["MINCHEM_QUICK_NAVIGATOR"] = "MINCHEM_QUICK_NAVIGATOR";
    QuickNavigatorTypes["SOLVEXTRACT_QUICK_NAVIGATOR"] = "SOLVEXTRACT_QUICK_NAVIGATOR";
    QuickNavigatorTypes["CUSTOM_QUICK_NAVIGATOR"] = "CUSTOM_QUICK_NAVIGATOR";
})(QuickNavigatorTypes || (QuickNavigatorTypes = {}));
var pageQuickNavigatorObservableId = ObservableTypes.QUICK_NAVIGATOR;
var setQuickNavigatorBackToLink = function (label, link) {
    var msg = {
        type: QuickNavigatorTypes.QUICK_NAVIGATOR_BACK,
        label: label,
        link: link,
    };
    PubSub.publish(pageQuickNavigatorObservableId, msg);
};
var setQuickNavigatorBackToCallback = function (label, callback) {
    var msg = {
        type: QuickNavigatorTypes.QUICK_NAVIGATOR_BACK,
        label: label,
        callback: callback,
    };
    PubSub.publish(pageQuickNavigatorObservableId, msg);
};
var setQuickNavigatorSolvExtract = function () {
    var msg = {
        type: QuickNavigatorTypes.SOLVEXTRACT_QUICK_NAVIGATOR,
    };
    PubSub.publish(pageQuickNavigatorObservableId, msg);
};
var setQuickNavigatorMinChem = function () {
    var msg = {
        type: QuickNavigatorTypes.MINCHEM_QUICK_NAVIGATOR,
    };
    PubSub.publish(pageQuickNavigatorObservableId, msg);
};
var removeQuickNavigator = function () {
    var msg = {
        type: QuickNavigatorTypes.NOTHING,
    };
    PubSub.publish(pageQuickNavigatorObservableId, msg);
};
var QuickNavigatorObservable = {
    setQuickNavigatorBackToLink: setQuickNavigatorBackToLink,
    setQuickNavigatorBackToCallback: setQuickNavigatorBackToCallback,
    setQuickNavigatorSolvExtract: setQuickNavigatorSolvExtract,
    setQuickNavigatorMinChem: setQuickNavigatorMinChem,
    removeQuickNavigator: removeQuickNavigator,
    observable: __assign(__assign({}, PubSub), { subscribe: function (func) {
            PubSub.subscribe(pageQuickNavigatorObservableId, func);
        } }),
};

var ToastType;
(function (ToastType) {
    ToastType["INFO"] = "INFO";
    ToastType["ERROR"] = "ERROR";
    ToastType["SUCCESS"] = "SUCCESS";
})(ToastType || (ToastType = {}));
var toastObservableId = ObservableTypes.TOAST;
var publishToast = function (toastType, message) {
    PubSub.publish(toastObservableId, { toastType: toastType, message: message });
};
var showErrorToast = function (errorMessage) {
    publishToast(ToastType.ERROR, errorMessage);
};
var showInfoToast = function (infoMessage) {
    publishToast(ToastType.INFO, infoMessage);
};
var showSuccessToast = function (successMessage) {
    publishToast(ToastType.SUCCESS, successMessage);
};
var ToastObservable = {
    showErrorToast: showErrorToast,
    showInfoToast: showInfoToast,
    showSuccessToast: showSuccessToast,
    observable: __assign(__assign({}, PubSub), { subscribe: function (func) {
            PubSub.subscribe(toastObservableId, func);
        } }),
};

export { ObservableTypes, PageTitleObservable, QuickNavigatorObservable, ToastObservable };
//# sourceMappingURL=index.js.map
